if ($('.js-sliderServices').length > 0) {
    const sliderServicesElem = $('.js-sliderServices');

    function addZero(i) {
        if (i < 10) {
            i = '0' + i;
        }
        return i;
    }

    var speedSlider = 1300;
    let ww = $(window).width();
    let progressSlider = $('.js-progressSlider');
    var sliderCounterCurrent = $('.js-sliderServices .js-sliderCounterCurrent');
    let sliderCounterFull = $('.js-sliderServices .js-sliderCounterFull');

    if (ww < 1024) {
        speedSlider = 600;
    }

    const sliderServices = new Swiper(".js-sliderServices .swiper-container", {
        slidesPerView: 1,
        loop: true,
        autoplay: false,
		autoHeight: true,
        // navigation: {
        //     nextEl: '.js-sliderServices .swiper-next',
        //     prevEl: '.js-sliderServices .swiper-prev',
        // },
        speed: speedSlider,
        on: {
            init: function () {
                progressSlider.addClass('is-active');
            },
        },
    });

    sliderServices.on('slideChange', function () {
        sliderCounterCurrent.text(addZero(this.realIndex + 1));

        progressSlider.removeClass('is-active');
        setTimeout(function() {
          progressSlider.addClass('is-active');
        }, 900);
    });

    var curs = document.querySelector('.cursor');
    var sliderServicesBlock = document.querySelector('.js-sliderServices');
    let positionSlider = $('.js-sliderServices').offset().top;
    let sliderWidth = $('.js-sliderServices').width();
    let sliderOffsetLeft = sliderWidth / 2;

    $(window).on('resize', function() {
        positionSlider = $('.js-sliderServices').offset().top;
        sliderWidth = $('.js-sliderServices').width();
    });

    if (sliderServicesBlock && sliderServicesBlock.length !== 0) {
      document.addEventListener('mousemove', function (e) {
        var x = e.pageX;
        var y = e.pageY;
        curs.style.left = x - 40  + "px";
        curs.style.top = y - 50 - positionSlider + "px";
      });
    }

    $(document).on('click', '.js-sliderServices .services-banner', function(e) {
        let x = e.pageX;

        if ($('.hover_link').length < 1) {
            if (x > sliderOffsetLeft) {
                sliderServices.slideNext();
            } else {
                sliderServices.slidePrev();
            }
        }
    });

    $(document).on('mousemove', '.js-sliderServices a', function(e) {
        sliderServicesElem.addClass('hover_link');

    });

    $(document).on('mouseleave', '.js-sliderServices a', function(e) {
        sliderServicesElem.removeClass('hover_link');

    });

    $('.js-sliderServices').on('mousemove', function (e) {
      $('.cursor').addClass('visible');

      let x = e.pageX;

      if (x > sliderOffsetLeft) {
        $('.cursor').removeClass('show-prev');
        $('.cursor').addClass('show-next');
      } else {
        $('.cursor').removeClass('show-next');
        $('.cursor').addClass('show-prev');
      }
    })
      .on('mouseleave', function () {
        $('.cursor').removeClass('visible');
      })
}
